/**
 * Shared footer for all InterviewManager wizards (InterviewActivity + ScheduleInterview).
 * Renders: Back (optional) | Cancel + Secondary CTA (optional) + Primary
 */
import { Flex } from '@chakra-ui/react';
import { Button } from '@kula-ai/components';
import { ArrowLeft } from '@kula-ai/icons-core';

export interface WizardFooterProps {
  disabled: boolean;
  canGoBack: boolean;
  backButtonLabel?: string;
  primaryButtonLabel: string;
  cancelLabel?: string;
  onBack: () => void;
  onCancel: () => void;
  onPrimary: () => void;
  secondaryCta?: { label: string; onClick: () => void };
}

export const WizardFooter = ({
  disabled,
  canGoBack,
  backButtonLabel,
  primaryButtonLabel,
  cancelLabel = 'Cancel',
  onBack,
  onCancel,
  onPrimary,
  secondaryCta,
}: WizardFooterProps) => {
  return (
    <Flex justifyContent="space-between" align="center" gap="3">
      <Flex>
        {canGoBack && backButtonLabel && (
          <Button
            variant="quaternary"
            leftElement={<ArrowLeft size={16} />}
            disabled={disabled}
            onClick={onBack}
          >
            {backButtonLabel}
          </Button>
        )}
      </Flex>

      <Flex gap="3">
        <Button variant="secondary" disabled={disabled} onClick={onCancel}>
          {cancelLabel}
        </Button>
        {secondaryCta && (
          <Button
            variant="secondary"
            disabled={disabled}
            onClick={secondaryCta.onClick}
          >
            {secondaryCta.label}
          </Button>
        )}
        <Button variant="primary" disabled={disabled} onClick={onPrimary}>
          {primaryButtonLabel}
        </Button>
      </Flex>
    </Flex>
  );
};
